var React = require('react');

function BatteryPower (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3.112 12H16a1 1 0 110 2H3.112a1 1 0 00-1 1v18a1 1 0 001 1H16a1 1 0 110 2H3.112a3 3 0 01-3-3V15a3 3 0 013-3zM28 35a1 1 0 001 1h10.112a3 3 0 003-3v-3h3a3 3 0 003-3v-6a3 3 0 00-3-3h-3v-3a3 3 0 00-3-3H29a1 1 0 100 2h10.112a1 1 0 011 1v4a1 1 0 001 1h4a1 1 0 011 1v6a1 1 0 01-1 1h-4a1 1 0 00-1 1v4a1 1 0 01-1 1H29a1 1 0 00-1 1z","key":0}),React.createElement("path",{"d":"M4.112 17a1 1 0 112 0v14a1 1 0 11-2 0V17z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23.855 9.03a1 1 0 01.754.97v9.316H31a1 1 0 01.879 1.477L22.27 38.477A1 1 0 0120.391 38v-9.316H14a1 1 0 01-.879-1.477L22.73 9.523a1 1 0 011.125-.492zm-8.174 17.654h5.71a1 1 0 011 1v6.381l6.928-12.75h-5.71a1 1 0 01-1-1v-6.38l-6.928 12.75z","key":2})]);
}

BatteryPower.defaultProps = {"viewBox":"0 0 49 48"};

module.exports = BatteryPower;

BatteryPower.default = BatteryPower;
